import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=0297867b&scoped=true&"
import script from "./Main.vue?vue&type=script&lang=js&"
export * from "./Main.vue?vue&type=script&lang=js&"
import style0 from "./Main.scss?vue&type=style&index=0&id=0297867b&lang=scss&scoped=true&"
import style1 from "./Main.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0297867b",
  null
  
)

export default component.exports